<template>
    <div
        class="tw:bg-white tw:rounded-2xl tw:shadow-sm tw:border tw:border-slate-100 tw:overflow-hidden tw:transition-all">
        <!-- Header opcional -->
        <div v-if="$slots.header"
            class="tw:px-6 tw:py-4 tw:border-b tw:border-slate-100 tw:flex tw:items-center tw:justify-between">
            <slot name="header"></slot>
        </div>

        <!-- Body principal -->
        <div class="tw:p-6" :class="bodyClass">
            <slot></slot>
        </div>

        <!-- Footer opcional -->
        <div v-if="$slots.footer" class="tw:px-6 tw:py-4 tw:bg-slate-50/50 tw:border-t tw:border-slate-100">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseCard',
    props: {
        // Permite pasar clases adicionales al body si se necesita algún espaciado especial
        bodyClass: {
            type: String,
            default: ''
        }
    }
}
</script>